import * as React from 'react'
import Svg, { SvgProps, Circle, Path } from 'react-native-svg'

const TransferSend = (props: SvgProps) => (
  <Svg width="46" height="46" fill="none" viewBox="0 0 32 32" {...props}>
    <Circle cx="16" cy="16" r="13.638" stroke="#7D8893" strokeWidth="1.524" />
    <Path
      stroke="#7D8893"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2.286"
      d="m12.384 19.68 7.09-7.211M13.665 12.477l5.81-.008.008 5.892"
    />
  </Svg>
)

export default TransferSend
